import { Typography, styled } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { Orientations } from '~/engine/view/views/PlaneView';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';

const BaseViewportOrientation = styled(Typography)`
    color: ${({ theme }) => theme.palette.text.primary};
    position: absolute;
    font-size: 0.8em;
    user-select: none;
    z-index: 3;
    font-family: 'Roboto Mono';
    font-size: 11px;
`;

const ViewportOrientationTop = styled(BaseViewportOrientation)`
    top: 15px;
    left: 50%;
`;

const ViewportOrientationBottom = styled(BaseViewportOrientation)`
    bottom: 15px;
    left: 50%;
`;

const ViewportOrientationLeft = styled(BaseViewportOrientation)`
    top: 50%;
    left: 15px;
`;

const ViewportOrientationRight = styled(BaseViewportOrientation)`
    top: 50%;
    right: 15px;
`;

interface ViewportDirectionLabelsProp {
    viewportOrientation: string;
}

const LabelDirections = ({
    viewportOrientation,
}: ViewportDirectionLabelsProp) => {
    const primaryImage = useRecoilValue(primaryImageState);
    const isPatientOrientationHFP = primaryImage?.firstSlice.headFirstProne;
    const directionLabels =
        viewportOrientation === Orientations.TRANSVERSAL_ORIENTATION
            ? isPatientOrientationHFP
                ? ['L', 'P', 'R', 'A']
                : ['R', 'A', 'L', 'P']
            : viewportOrientation === Orientations.SAGITTAL_ORIENTATION
              ? isPatientOrientationHFP
                  ? ['A', 'H', 'P', 'F']
                  : ['P', 'H', 'A', 'F']
              : isPatientOrientationHFP
                ? ['L', 'H', 'R', 'F']
                : ['R', 'H', 'L', 'F'];

    return (
        <>
            <ViewportOrientationLeft>
                {directionLabels[0]}
            </ViewportOrientationLeft>
            <ViewportOrientationTop>
                {directionLabels[1]}
            </ViewportOrientationTop>
            <ViewportOrientationRight>
                {directionLabels[2]}
            </ViewportOrientationRight>
            <ViewportOrientationBottom>
                {directionLabels[3]}
            </ViewportOrientationBottom>
        </>
    );
};

export default LabelDirections;
